import { render, staticRenderFns } from "./SucessoModalComToken.vue?vue&type=template&id=528ca4e5"
import script from "./SucessoModalComToken.vue?vue&type=script&lang=js"
export * from "./SucessoModalComToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports